/* eslint-disable react/prop-types */
import { Avatar, Box, Checkbox, Typography, Tooltip } from '@mui/material';
import { capitalize } from '../../hepler/functions';
import stylesLogo from './Account.styles';
import sizeFontCustom from '../Discovery/fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { isAccountMandatory } from '../../utils/targetedAccounts.utils';

function AccountCheckBox(props) {
	// eslint-disable-next-line no-unused-vars
	const { t } = useTranslation();
	const {
		acc,
		checkedItems,
		handleCheckboxChange,
		selectedAccounts,
		consent,
		superState,
		fip,
		accountRestrictions,
		...rest
	} = props;
	const isActiveFlag = rest?.selectedConsentsState?.includes(
		rest?.consentHandle
	)
		? true
		: false;

	const isMandatory = isAccountMandatory(acc);

	// Check if this account is restricted for the current consent
	const accountRestriction = accountRestrictions?.[acc?.accRefNumber];
	const isRestricted = accountRestriction?.isRestricted || false;
	const restrictionReason = accountRestriction?.reason || '';

	// Determine if checkbox should be checked and disabled
	const isChecked = consent
		? superState?.consentSelectedAccounts[consent.ConsentHandle]?.includes(acc)
		: selectedAccounts?.includes(acc) || false;

	// Only disable if consent is not active OR account is restricted
	const isDisabled = !isActiveFlag || isRestricted || isMandatory;

	const handleClick = (e) => {
		// Only prevent click if account is restricted
		if (isRestricted) {
			e.preventDefault();
			e.stopPropagation();
			return;
		}

		// For non-restricted accounts, allow the click
		handleCheckboxChange(e, acc, isMandatory);
	};

	return (
		<Tooltip
			title={isRestricted ? restrictionReason : ''}
			arrow
			placement="top"
			disableHoverListener={!isRestricted}
		>
			<Box
				onClick={handleClick}
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					cursor: isRestricted ? 'not-allowed' : 'pointer',
					alignItems: 'flex-start',
					p: '1rem',
					opacity: isRestricted ? 0.6 : 1,
				}}
			>
				<Box sx={stylesLogo.container}>
					<Avatar
						alt={acc?.name}
						src={global.objectFormatFip[acc?.fipId]?.productIconUri}
						sx={stylesLogo.avatarStyle}
					/>
					<Box textAlign={'left'}>
						<Typography sx={sizeFontCustom.subHeading} noWrap={false}>
							{t(`fips.${global.objectFormatFip[acc?.fipId]?.fipId}`)}
						</Typography>

						<Typography sx={stylesLogo.account}>
							{capitalize(acc?.accType) +
								' ' +
								acc?.maskedAccNumber?.replaceAll('X', '\u2022')}
						</Typography>
					</Box>
				</Box>
				<Box>
					<Checkbox
						name={acc?.accRefNumber}
						disabled={isDisabled}
						size="small"
						sx={{ height: '18px', width: '18px' }}
						checked={isRestricted ? false : isChecked}
						onChange={(e) => {
							// Only handle change if not restricted
							if (!isRestricted) {
								handleCheckboxChange(e, acc);
							}
						}}
					/>
				</Box>
			</Box>
		</Tooltip>
	);
}

export default AccountCheckBox;
